import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { graphql } from 'gatsby';
import { Button } from 'chaoskit/src/components';

import BaseLayout from '../layouts/BaseLayout';
import Hero from '../partials/Hero';
import { ActionCard, Data, Icon } from '../components';

const GameDay = props => {
  const {
    data: {
      file: { childDataYaml: pageData },
    },
  } = props;

  return (
    <BaseLayout headerProps={{ contrast: false, community: true }}>
      <Helmet
        title={pageData.title}
        meta={[{ name: 'description', content: pageData.description }]}
      />
      <Hero compact particles={false} className="community__hero">
        <div className="hero-content">
          <div className="container">
            <div className="hero-titleWrapper">
              <h1 className="hero-title">
                <Data>{pageData.hero.heading}</Data>
              </h1>
            </div>
          </div>
        </div>
      </Hero>
      <section className="section section--large u-bgPanel">
        <div className="container">
          <div className="section-titleWrapper">
            <h3 className="section-title">
              <Data>{pageData.files.heading}</Data>
            </h3>
            <div className="section-titleSub">
              <Data markdown>{pageData.files.blurb}</Data>
            </div>
          </div>
          <ul className="blockGrid blockGrid-2@small blockGrid-3@medium blockGrid--largeGutter blockGrid--deepMatch">
            {pageData.files.downloads.map(download => (
              <li key={download.title}>
                <ActionCard url={download.src} contentClassName="u-textCenter">
                  <Icon
                    icon="download"
                    size="large"
                    className="u-mr--small u-textPrimary"
                  />
                  <Data>{download.title}</Data>
                </ActionCard>
              </li>
            ))}
          </ul>
          <div className="u-textCenter u-mt--xlarge">
            <Button type="outlinePrimary" url={pageData.files.packageDownload}>
              Download All
            </Button>
          </div>
        </div>
      </section>
    </BaseLayout>
  );
};

GameDay.propTypes = {
  data: PropTypes.object.isRequired,
};

export default GameDay;

export const pageQuery = graphql`
  query GameDayPageData {
    file(name: { eq: "gameday" }) {
      childDataYaml {
        title
        description
        hero {
          heading
        }
        files {
          heading
          blurb
          downloads {
            src
            title
          }
          packageDownload
        }
      }
    }
  }
`;
